import { FormikNetworkSelect } from '@/components/forms';

interface Props {
  supportedChainIds: number[];
}

export default function NetworkSelector({ supportedChainIds }: Props) {
  return <FormikNetworkSelect supportedChainIds={supportedChainIds} />;
}
